module.exports = __webpack_public_path__ + "/images/shop/computop-form/help.svg";